module.exports = __webpack_public_path__ + "img/4.1dc80d73.jpg";